/* tslint:disable */
/* eslint-disable */
/**
 * Sprava Pripomienok Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AddSubjektBezPripomienok
 */
export interface AddSubjektBezPripomienok {
    /**
     * 
     * @type {string}
     * @memberof AddSubjektBezPripomienok
     */
    'orgId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddSubjektBezPripomienok
     */
    'datumOdoslania': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ClassTypeEnum = {
    Pripomienka: 'PRIPOMIENKA',
    HromadnaPripomienka: 'HROMADNA_PRIPOMIENKA'
} as const;

export type ClassTypeEnum = typeof ClassTypeEnum[keyof typeof ClassTypeEnum];


/**
 * 
 * @export
 * @interface FilterData
 */
export interface FilterData {
    /**
     * 
     * @type {Array<Priradeny>}
     * @memberof FilterData
     */
    'priradeny'?: Array<Priradeny>;
    /**
     * 
     * @type {Array<PouzivatelskaSkupinaSubjekt>}
     * @memberof FilterData
     */
    'pripomienkujuciSubjekt'?: Array<PouzivatelskaSkupinaSubjekt>;
}
/**
 * 
 * @export
 * @interface HromadneVyhodnotenie
 */
export interface HromadneVyhodnotenie {
    /**
     * 
     * @type {Array<string>}
     * @memberof HromadneVyhodnotenie
     */
    'pripomienkaUuidList'?: Array<string>;
    /**
     * 
     * @type {StavPripomienkyEnum}
     * @memberof HromadneVyhodnotenie
     */
    'stavPripomienky'?: StavPripomienkyEnum;
    /**
     * 
     * @type {string}
     * @memberof HromadneVyhodnotenie
     */
    'textVyhodnotenia'?: string;
}


/**
 * 
 * @export
 * @interface LdapSearchItem
 */
export interface LdapSearchItem {
    /**
     * 
     * @type {string}
     * @memberof LdapSearchItem
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof LdapSearchItem
     */
    'fullName': string;
    /**
     * 
     * @type {string}
     * @memberof LdapSearchItem
     */
    'shortName': string;
}
/**
 * 
 * @export
 * @interface LpBasicInfo
 */
export interface LpBasicInfo {
    /**
     * 
     * @type {string}
     * @memberof LpBasicInfo
     */
    'datumKoncaMpk'?: string;
    /**
     * 
     * @type {StadiumMaterialuEnum}
     * @memberof LpBasicInfo
     */
    'stadiumProcesu'?: StadiumMaterialuEnum;
    /**
     * 
     * @type {string}
     * @memberof LpBasicInfo
     */
    'stadiumProcesuValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof LpBasicInfo
     */
    'nazovPredpisu'?: string;
    /**
     * 
     * @type {string}
     * @memberof LpBasicInfo
     */
    'legMaterialUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof LpBasicInfo
     */
    'legMaterialCislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof LpBasicInfo
     */
    'typCode'?: string;
    /**
     * 
     * @type {Pouzivatel}
     * @memberof LpBasicInfo
     */
    'aktualnyPredkladatel'?: Pouzivatel;
    /**
     * 
     * @type {Organizacia}
     * @memberof LpBasicInfo
     */
    'zodpovednaInstitucia'?: Organizacia;
    /**
     * 
     * @type {Organizacia}
     * @memberof LpBasicInfo
     */
    'aktualnaInstitucia'?: Organizacia;
    /**
     * 
     * @type {Organizacia}
     * @memberof LpBasicInfo
     */
    'gestor'?: Organizacia;
    /**
     * 
     * @type {Array<Organizacia>}
     * @memberof LpBasicInfo
     */
    'spolugestorList'?: Array<Organizacia>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OdoslanaPripomienkaStatusEnum = {
    Exists: 'PRIPOMIENKA_EXISTS',
    NotFound: 'PRIPOMIENKA_NOT_FOUND'
} as const;

export type OdoslanaPripomienkaStatusEnum = typeof OdoslanaPripomienkaStatusEnum[keyof typeof OdoslanaPripomienkaStatusEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const OpravnenieEnum = {
    Verejnost: 'VEREJNOST',
    Pripomienkovatel: 'PRIPOMIENKOVATEL',
    Vyhodnocovatel: 'VYHODNOCOVATEL',
    Odosielatel: 'ODOSIELATEL',
    Superadmin: 'SUPERADMIN',
    NelegislativnaOrganizacia: 'NELEGISLATIVNA_ORGANIZACIA',
    AktyEu: 'AKTY_EU',
    AktyEuSpravca: 'AKTY_EU_SPRAVCA',
    Clen: 'CLEN',
    PredkladatelNeleg: 'PREDKLADATEL_NELEG',
    PredkladatelLeg: 'PREDKLADATEL_LEG',
    PredkladatelZodp: 'PREDKLADATEL_ZODP'
} as const;

export type OpravnenieEnum = typeof OpravnenieEnum[keyof typeof OpravnenieEnum];


/**
 * 
 * @export
 * @interface Organizacia
 */
export interface Organizacia {
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'skratenyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'ldapUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Organizacia
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface Page
 */
export interface Page {
    /**
     * total count of elements
     * @type {number}
     * @memberof Page
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof Page
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof Page
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface Podporovatel
 */
export interface Podporovatel {
    /**
     * 
     * @type {string}
     * @memberof Podporovatel
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof Podporovatel
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Podporovatel
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Podporovatel
     */
    'organizacia': string;
    /**
     * 
     * @type {string}
     * @memberof Podporovatel
     */
    'datum': string;
}
/**
 * 
 * @export
 * @interface PodporovatelListPage
 */
export interface PodporovatelListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof PodporovatelListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof PodporovatelListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof PodporovatelListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<Podporovatel>}
     * @memberof PodporovatelListPage
     */
    'podporovatelList'?: Array<Podporovatel>;
}
/**
 * 
 * @export
 * @interface Pouzivatel
 */
export interface Pouzivatel {
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'skratenyNazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pouzivatel
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface PouzivatelskaSkupinaSubjekt
 */
export interface PouzivatelskaSkupinaSubjekt {
    /**
     * 
     * @type {string}
     * @memberof PouzivatelskaSkupinaSubjekt
     */
    'uuid': string;
    /**
     * 
     * @type {string}
     * @memberof PouzivatelskaSkupinaSubjekt
     */
    'kratkeMeno': string;
    /**
     * 
     * @type {string}
     * @memberof PouzivatelskaSkupinaSubjekt
     */
    'popis': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PovahaHromadnejPripomienkyEnum = {
    Obycajna: 'OBYCAJNA',
    Zasadna: 'ZASADNA',
    ZasadnaSRozporom: 'ZASADNA_S_ROZPOROM'
} as const;

export type PovahaHromadnejPripomienkyEnum = typeof PovahaHromadnejPripomienkyEnum[keyof typeof PovahaHromadnejPripomienkyEnum];


/**
 * 
 * @export
 * @interface PripomienkaDetail
 */
export interface PripomienkaDetail {
    /**
     * 
     * @type {string}
     * @memberof PripomienkaDetail
     */
    'uuid': string;
    /**
     * 
     * @type {number}
     * @memberof PripomienkaDetail
     */
    'pocetPodporovatelov'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PripomienkaDetail
     */
    'somPodporovatel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaDetail
     */
    'datumPripomienkovania': string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaDetail
     */
    'pripomienkaK': string;
    /**
     * 
     * @type {boolean}
     * @memberof PripomienkaDetail
     */
    'odoslana': boolean;
    /**
     * 
     * @type {LdapSearchItem}
     * @memberof PripomienkaDetail
     */
    'pripomienkujuciSubjekt': LdapSearchItem;
    /**
     * 
     * @type {StavPripomienkyEnum}
     * @memberof PripomienkaDetail
     */
    'stav': StavPripomienkyEnum;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaDetail
     */
    'textPripomienky': string;
    /**
     * 
     * @type {PovahaHromadnejPripomienkyEnum}
     * @memberof PripomienkaDetail
     */
    'povahaPripomienky'?: PovahaHromadnejPripomienkyEnum;
    /**
     * 
     * @type {TypPripomienkyEnum}
     * @memberof PripomienkaDetail
     */
    'typPripomienky': TypPripomienkyEnum;
    /**
     * 
     * @type {LdapSearchItem}
     * @memberof PripomienkaDetail
     */
    'pripomienkovatel'?: LdapSearchItem;
    /**
     * 
     * @type {LdapSearchItem}
     * @memberof PripomienkaDetail
     */
    'priradeny'?: LdapSearchItem;
    /**
     * 
     * @type {LdapSearchItem}
     * @memberof PripomienkaDetail
     */
    'vyhodnotil'?: LdapSearchItem;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaDetail
     */
    'textVyhodnotenia'?: string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaDetail
     */
    'predchadzajucaPripomienkaId': string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaDetail
     */
    'nasledujucaPripomienkaId': string;
}


/**
 * 
 * @export
 * @interface PripomienkaFilter
 */
export interface PripomienkaFilter {
    /**
     * 
     * @type {string}
     * @memberof PripomienkaFilter
     */
    'hladanyVyraz'?: string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaFilter
     */
    'datumDoruceniaOd'?: string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaFilter
     */
    'datumDoruceniaDo'?: string;
    /**
     * 
     * @type {Array<TypPripomienkyEnum>}
     * @memberof PripomienkaFilter
     */
    'typyPripomienok'?: Array<TypPripomienkyEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PripomienkaFilter
     */
    'pripomienkujuceSubjekty'?: Array<string>;
    /**
     * 
     * @type {Array<StavPripomienkyEnum>}
     * @memberof PripomienkaFilter
     */
    'vyhodnotenia'?: Array<StavPripomienkyEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PripomienkaFilter
     */
    'priradeniPouzivatelia'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof PripomienkaFilter
     */
    'nepriradenyPouzivatel'?: boolean;
}
/**
 * 
 * @export
 * @interface PripomienkaListItem
 */
export interface PripomienkaListItem {
    /**
     * 
     * @type {string}
     * @memberof PripomienkaListItem
     */
    'uuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof PripomienkaListItem
     */
    'odoslana': boolean;
    /**
     * 
     * @type {StavPripomienkyEnum}
     * @memberof PripomienkaListItem
     */
    'stav': StavPripomienkyEnum;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaListItem
     */
    'textPripomienky': string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaListItem
     */
    'pripomienkaK': string;
    /**
     * 
     * @type {TypPripomienkyEnum}
     * @memberof PripomienkaListItem
     */
    'typPripomienky': TypPripomienkyEnum;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaListItem
     */
    'datumPripomienky': string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaListItem
     */
    'pripomienkujuciSubjekt': string;
    /**
     * 
     * @type {string}
     * @memberof PripomienkaListItem
     */
    'priradeny': string;
    /**
     * 
     * @type {number}
     * @memberof PripomienkaListItem
     */
    'pocetPodporovatelov': number;
}


/**
 * 
 * @export
 * @interface PripomienkaListPage
 */
export interface PripomienkaListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof PripomienkaListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof PripomienkaListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof PripomienkaListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<PripomienkaListItem>}
     * @memberof PripomienkaListPage
     */
    'pripomienkaList'?: Array<PripomienkaListItem>;
}
/**
 * 
 * @export
 * @interface Priradeny
 */
export interface Priradeny {
    /**
     * 
     * @type {string}
     * @memberof Priradeny
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Priradeny
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface SaveAdminPripomienka
 */
export interface SaveAdminPripomienka {
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'pripomienkujuciSubjekt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'pripomienkovatel'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'datumVytvorenia': string;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'textPripomienky'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'clanok'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'paragraf'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'odsek'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'ine'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAdminPripomienka
     */
    'celyMaterial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAdminPripomienka
     */
    'zasadna'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAdminPripomienka
     */
    'odoslana': boolean;
    /**
     * 
     * @type {PovahaHromadnejPripomienkyEnum}
     * @memberof SaveAdminPripomienka
     */
    'povahaPripomienky'?: PovahaHromadnejPripomienkyEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'priradeny'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'vyhodnotil'?: string;
    /**
     * 
     * @type {StavPripomienkyEnum}
     * @memberof SaveAdminPripomienka
     */
    'stav': StavPripomienkyEnum;
    /**
     * 
     * @type {string}
     * @memberof SaveAdminPripomienka
     */
    'textVyhodnotenia'?: string;
}


/**
 * 
 * @export
 * @interface SavePripomienka
 */
export interface SavePripomienka {
    /**
     * 
     * @type {string}
     * @memberof SavePripomienka
     */
    'textPripomienky': string;
    /**
     * 
     * @type {string}
     * @memberof SavePripomienka
     */
    'clanok'?: string;
    /**
     * 
     * @type {string}
     * @memberof SavePripomienka
     */
    'paragraf'?: string;
    /**
     * 
     * @type {string}
     * @memberof SavePripomienka
     */
    'odsek'?: string;
    /**
     * 
     * @type {string}
     * @memberof SavePripomienka
     */
    'ine'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SavePripomienka
     */
    'celyMaterial'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SavePripomienka
     */
    'zasadna'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SortDirectionEnum = typeof SortDirectionEnum[keyof typeof SortDirectionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const StadiumMaterialuEnum = {
    FinalnePredbezneStanovisko: 'FINALNE_PREDBEZNE_STANOVISKO',
    Mpk: 'MPK',
    PredVyhlasenimVZbierke: 'PRED_VYHLASENIM_V_ZBIERKE',
    PredpripravnaFazaUkoncena: 'PREDPRIPRAVNA_FAZA_UKONCENA',
    PripravaMaterialu: 'PRIPRAVA_MATERIALU',
    PriradenieGestora: 'PRIRADENIE_GESTORA',
    ProcesUkonceny: 'PROCES_UKONCENY',
    RokovanieNrsr: 'ROKOVANIE_NRSR',
    RokovaniePov: 'ROKOVANIE_POV',
    RokovanieVlada: 'ROKOVANIE_VLADA',
    SchvalenieGestora: 'SCHVALENIE_GESTORA',
    SchvalovanieMinister: 'SCHVALOVANIE_MINISTER',
    SpracovaniePredkladatel: 'SPRACOVANIE_PREDKLADATEL',
    VyhlaseneVZbierke: 'VYHLASENE_V_ZBIERKE',
    VyhodnotenieMpk: 'VYHODNOTENIE_MPK',
    VyhodnotenieMpkAkty: 'VYHODNOTENIE_MPK_AKTY',
    Vyjadrenia: 'VYJADRENIA',
    ZapisStanoviska: 'ZAPIS_STANOVISKA',
    ZapisPredbeznehoStanoviska: 'ZAPIS_PREDBEZNEHO_STANOVISKA',
    ZapisDoplnenehoPredbeznehoStanoviska: 'ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA',
    AdministraciaProcesu: 'ADMINISTRACIA_PROCESU',
    AproximaciaNariadenia: 'APROXIMACIA_NARIADENIA',
    AproximaciaSmernice: 'APROXIMACIA_SMERNICE',
    ArchivovanyAeu: 'ARCHIVOVANY_AEU',
    CakajuciPubMod: 'CAKAJUCI_PUB_MOD',
    DoplneniePozicie: 'DOPLNENIE_POZICIE',
    FinalizaciaInstrukcie: 'FINALIZACIA_INSTRUKCIE',
    FinalizaciaNotifikacnychFormularov: 'FINALIZACIA_NOTIFIKACNYCH_FORMULAROV',
    FinalizaciaPozicie: 'FINALIZACIA_POZICIE',
    KontrolaRedakcUprav: 'KONTROLA_REDAKC_UPRAV',
    MzvEz: 'MZV_EZ',
    NotifikacnyFormular: 'NOTIFIKACNY_FORMULAR',
    OdoslaneRokovanieNrsr: 'ODOSLANE_ROKOVANIE_NRSR',
    OdoslaneRokovanieVlady: 'ODOSLANE_ROKOVANIE_VLADY',
    OdoslaneZz: 'ODOSLANE_ZZ',
    PredPublikovanim: 'PRED_PUBLIKOVANIM',
    PriebezneZapracovaniePrip: 'PRIEBEZNE_ZAPRACOVANIE_PRIP',
    PripomienkovaniePozmenNavrhovNrsr: 'PRIPOMIENKOVANIE_POZMEN_NAVRHOV_NRSR',
    PripravaMaterialuAdmin: 'PRIPRAVA_MATERIALU_ADMIN',
    PripravaMaterialuPi: 'PRIPRAVA_MATERIALU_PI',
    PripravaNelegMaterialu: 'PRIPRAVA_NELEG_MATERIALU',
    PriradenieGestoraCoreper: 'PRIRADENIE_GESTORA_COREPER',
    PriradenieGestoraNariadenie: 'PRIRADENIE_GESTORA_NARIADENIE',
    PriradenieGestoraRadaEu: 'PRIRADENIE_GESTORA_RADA_EU',
    PriradenieGestoraSmernica: 'PRIRADENIE_GESTORA_SMERNICA',
    PublikaciaRo: 'PUBLIKACIA_RO',
    RokovanieLrv: 'ROKOVANIE_LRV',
    RokovanieNrsrNelegMat: 'ROKOVANIE_NRSR_NELEG_MAT',
    RokovaniePracKomisii: 'ROKOVANIE_PRAC_KOMISII',
    RokovaniePredkladatel: 'ROKOVANIE_PREDKLADATEL',
    RokovaniePredkladatelNelegMat: 'ROKOVANIE_PREDKLADATEL_NELEG_MAT',
    RokovanieVladaNelegMat: 'ROKOVANIE_VLADA_NELEG_MAT',
    SefredaktorPridelovanie: 'SEFREDAKTOR_PRIDELOVANIE',
    SefredaktorSchvaleniePredPubmod: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD',
    SefredaktorSchvaleniePredPubmodNelegMat: 'SEFREDAKTOR_SCHVALENIE_PRED_PUBMOD_NELEG_MAT',
    SchvaleneNaVlade: 'SCHVALENE_NA_VLADE',
    SchvalovaniePrezident: 'SCHVALOVANIE_PREZIDENT',
    SpracovanieRedaktor: 'SPRACOVANIE_REDAKTOR',
    SpracovanieRedaktorNelegMat: 'SPRACOVANIE_REDAKTOR_NELEG_MAT',
    SpracovanieSefredaktor: 'SPRACOVANIE_SEFREDAKTOR',
    SpracovanieSefredaktorNelegMat: 'SPRACOVANIE_SEFREDAKTOR_NELEG_MAT',
    VyhodnotenieMpkNelegMat: 'VYHODNOTENIE_MPK_NELEG_MAT',
    VyhodnotenieRokovaniaNrsr: 'VYHODNOTENIE_ROKOVANIA_NRSR',
    VyhodnotenieVysledkuRokovania: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA',
    VyhodnotenieVysledkuRokovaniaNelegMat: 'VYHODNOTENIE_VYSLEDKU_ROKOVANIA_NELEG_MAT',
    VytvorenieCiastkovejInstrukcie: 'VYTVORENIE_CIASTKOVEJ_INSTRUKCIE',
    VytvoreniePozicie: 'VYTVORENIE_POZICIE',
    ZaevidovanieMaterialu: 'ZAEVIDOVANIE_MATERIALU',
    ZaevidovanieOpatrenia: 'ZAEVIDOVANIE_OPATRENIA'
} as const;

export type StadiumMaterialuEnum = typeof StadiumMaterialuEnum[keyof typeof StadiumMaterialuEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const StavPripomienkyEnum = {
    Akceptovana: 'AKCEPTOVANA',
    CiastocneAkceptovana: 'CIASTOCNE_AKCEPTOVANA',
    Neakceptovana: 'NEAKCEPTOVANA',
    NeprihliadaSa: 'NEPRIHLIADA_SA',
    Nespracovana: 'NESPRACOVANA',
    Stornovana: 'STORNOVANA',
    Zrusena: 'ZRUSENA'
} as const;

export type StavPripomienkyEnum = typeof StavPripomienkyEnum[keyof typeof StavPripomienkyEnum];


/**
 * 
 * @export
 * @interface SubjektBezPripomienokListPage
 */
export interface SubjektBezPripomienokListPage {
    /**
     * total count of elements
     * @type {number}
     * @memberof SubjektBezPripomienokListPage
     */
    'totalElements': number;
    /**
     * current page number
     * @type {number}
     * @memberof SubjektBezPripomienokListPage
     */
    'number': number;
    /**
     * size of the page
     * @type {number}
     * @memberof SubjektBezPripomienokListPage
     */
    'size': number;
    /**
     * 
     * @type {Array<PouzivatelskaSkupinaSubjekt>}
     * @memberof SubjektBezPripomienokListPage
     */
    'subjektBezPripomienokList'?: Array<PouzivatelskaSkupinaSubjekt>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TypPripomienkyEnum = {
    Obycajna: 'OBYCAJNA',
    Zasadna: 'ZASADNA',
    Hromadna: 'HROMADNA'
} as const;

export type TypPripomienkyEnum = typeof TypPripomienkyEnum[keyof typeof TypPripomienkyEnum];


/**
 * 
 * @export
 * @interface UserDetail
 */
export interface UserDetail {
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'meno'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetail
     */
    'organizaciaMeno'?: string;
    /**
     * 
     * @type {Array<OpravnenieEnum>}
     * @memberof UserDetail
     */
    'opravnenia'?: Array<OpravnenieEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetail
     */
    'isPovinnyPripomienkovatel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetail
     */
    'isDalsiPripomienkovatel'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetail
     */
    'isOdoslaneBezPripomienok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetail
     */
    'pripomienkaExistsForUserOrg'?: boolean;
}
/**
 * 
 * @export
 * @interface UserDetailWithLp
 */
export interface UserDetailWithLp {
    /**
     * 
     * @type {UserDetail}
     * @memberof UserDetailWithLp
     */
    'user'?: UserDetail;
    /**
     * 
     * @type {LpBasicInfo}
     * @memberof UserDetailWithLp
     */
    'legislationProcess': LpBasicInfo;
    /**
     * 
     * @type {boolean}
     * @memberof UserDetailWithLp
     */
    'pripomienkaExistsForOrg'?: boolean;
}
/**
 * 
 * @export
 * @interface Uuid
 */
export interface Uuid {
    /**
     * 
     * @type {string}
     * @memberof Uuid
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface Vyhodnotenie
 */
export interface Vyhodnotenie {
    /**
     * 
     * @type {StavPripomienkyEnum}
     * @memberof Vyhodnotenie
     */
    'stavPripomienky'?: StavPripomienkyEnum;
    /**
     * 
     * @type {string}
     * @memberof Vyhodnotenie
     */
    'textVyhodnotenia'?: string;
}



/**
 * AddPripomienkaApi - axios parameter creator
 * @export
 */
export const AddPripomienkaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {SavePripomienka} savePripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPripomienka: async (classType: ClassTypeEnum, type: string, year: number, index: number, savePripomienka: SavePripomienka, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('addPripomienka', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('addPripomienka', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('addPripomienka', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('addPripomienka', 'index', index)
            // verify required parameter 'savePripomienka' is not null or undefined
            assertParamExists('addPripomienka', 'savePripomienka', savePripomienka)
            const localVarPath = `/{classType}/{type}/{year}/{index}/add-pripomienka`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePripomienka, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {SaveAdminPripomienka} saveAdminPripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPripomienkaAdmin: async (classType: ClassTypeEnum, type: string, year: number, index: number, saveAdminPripomienka: SaveAdminPripomienka, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('addPripomienkaAdmin', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('addPripomienkaAdmin', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('addPripomienkaAdmin', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('addPripomienkaAdmin', 'index', index)
            // verify required parameter 'saveAdminPripomienka' is not null or undefined
            assertParamExists('addPripomienkaAdmin', 'saveAdminPripomienka', saveAdminPripomienka)
            const localVarPath = `/{classType}/{type}/{year}/{index}/add-pripomienka-admin`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAdminPripomienka, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddPripomienkaApi - functional programming interface
 * @export
 */
export const AddPripomienkaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddPripomienkaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {SavePripomienka} savePripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPripomienka(classType: ClassTypeEnum, type: string, year: number, index: number, savePripomienka: SavePripomienka, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Uuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPripomienka(classType, type, year, index, savePripomienka, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddPripomienkaApi.addPripomienka']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {SaveAdminPripomienka} saveAdminPripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPripomienkaAdmin(classType: ClassTypeEnum, type: string, year: number, index: number, saveAdminPripomienka: SaveAdminPripomienka, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPripomienkaAdmin(classType, type, year, index, saveAdminPripomienka, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddPripomienkaApi.addPripomienkaAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddPripomienkaApi - factory interface
 * @export
 */
export const AddPripomienkaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddPripomienkaApiFp(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {SavePripomienka} savePripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPripomienka(classType: ClassTypeEnum, type: string, year: number, index: number, savePripomienka: SavePripomienka, options?: any): AxiosPromise<Uuid> {
            return localVarFp.addPripomienka(classType, type, year, index, savePripomienka, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {SaveAdminPripomienka} saveAdminPripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPripomienkaAdmin(classType: ClassTypeEnum, type: string, year: number, index: number, saveAdminPripomienka: SaveAdminPripomienka, options?: any): AxiosPromise<void> {
            return localVarFp.addPripomienkaAdmin(classType, type, year, index, saveAdminPripomienka, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddPripomienkaApi - object-oriented interface
 * @export
 * @class AddPripomienkaApi
 * @extends {BaseAPI}
 */
export class AddPripomienkaApi extends BaseAPI {
    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {SavePripomienka} savePripomienka 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddPripomienkaApi
     */
    public addPripomienka(classType: ClassTypeEnum, type: string, year: number, index: number, savePripomienka: SavePripomienka, options?: RawAxiosRequestConfig) {
        return AddPripomienkaApiFp(this.configuration).addPripomienka(classType, type, year, index, savePripomienka, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {SaveAdminPripomienka} saveAdminPripomienka 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddPripomienkaApi
     */
    public addPripomienkaAdmin(classType: ClassTypeEnum, type: string, year: number, index: number, saveAdminPripomienka: SaveAdminPripomienka, options?: RawAxiosRequestConfig) {
        return AddPripomienkaApiFp(this.configuration).addPripomienkaAdmin(classType, type, year, index, saveAdminPripomienka, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssignMeApi - axios parameter creator
 * @export
 */
export const AssignMeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMe: async (type: string, year: number, index: number, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('assignMe', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('assignMe', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('assignMe', 'index', index)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('assignMe', 'requestBody', requestBody)
            const localVarPath = `/pripomienky/{type}/{year}/{index}/priradit-mne`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssignMeApi - functional programming interface
 * @export
 */
export const AssignMeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssignMeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignMe(type: string, year: number, index: number, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignMe(type, year, index, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssignMeApi.assignMe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssignMeApi - factory interface
 * @export
 */
export const AssignMeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssignMeApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignMe(type: string, year: number, index: number, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.assignMe(type, year, index, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssignMeApi - object-oriented interface
 * @export
 * @class AssignMeApi
 * @extends {BaseAPI}
 */
export class AssignMeApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssignMeApi
     */
    public assignMe(type: string, year: number, index: number, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return AssignMeApiFp(this.configuration).assignMe(type, year, index, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EditPripomienkaApi - axios parameter creator
 * @export
 */
export const EditPripomienkaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {SavePripomienka} savePripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPripomienka: async (type: string, year: number, index: number, uuid: string, savePripomienka: SavePripomienka, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('editPripomienka', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('editPripomienka', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('editPripomienka', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('editPripomienka', 'uuid', uuid)
            // verify required parameter 'savePripomienka' is not null or undefined
            assertParamExists('editPripomienka', 'savePripomienka', savePripomienka)
            const localVarPath = `/PRIPOMIENKA/{type}/{year}/{index}/{uuid}/edit`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(savePripomienka, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {SaveAdminPripomienka} saveAdminPripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPripomienkaAdmin: async (classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, saveAdminPripomienka: SaveAdminPripomienka, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('editPripomienkaAdmin', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('editPripomienkaAdmin', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('editPripomienkaAdmin', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('editPripomienkaAdmin', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('editPripomienkaAdmin', 'uuid', uuid)
            // verify required parameter 'saveAdminPripomienka' is not null or undefined
            assertParamExists('editPripomienkaAdmin', 'saveAdminPripomienka', saveAdminPripomienka)
            const localVarPath = `/{classType}/{type}/{year}/{index}/{uuid}/edit-admin`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveAdminPripomienka, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EditPripomienkaApi - functional programming interface
 * @export
 */
export const EditPripomienkaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EditPripomienkaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {SavePripomienka} savePripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editPripomienka(type: string, year: number, index: number, uuid: string, savePripomienka: SavePripomienka, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editPripomienka(type, year, index, uuid, savePripomienka, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EditPripomienkaApi.editPripomienka']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {SaveAdminPripomienka} saveAdminPripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editPripomienkaAdmin(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, saveAdminPripomienka: SaveAdminPripomienka, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editPripomienkaAdmin(classType, type, year, index, uuid, saveAdminPripomienka, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EditPripomienkaApi.editPripomienkaAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EditPripomienkaApi - factory interface
 * @export
 */
export const EditPripomienkaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EditPripomienkaApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {SavePripomienka} savePripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPripomienka(type: string, year: number, index: number, uuid: string, savePripomienka: SavePripomienka, options?: any): AxiosPromise<void> {
            return localVarFp.editPripomienka(type, year, index, uuid, savePripomienka, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {SaveAdminPripomienka} saveAdminPripomienka 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPripomienkaAdmin(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, saveAdminPripomienka: SaveAdminPripomienka, options?: any): AxiosPromise<void> {
            return localVarFp.editPripomienkaAdmin(classType, type, year, index, uuid, saveAdminPripomienka, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EditPripomienkaApi - object-oriented interface
 * @export
 * @class EditPripomienkaApi
 * @extends {BaseAPI}
 */
export class EditPripomienkaApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {SavePripomienka} savePripomienka 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EditPripomienkaApi
     */
    public editPripomienka(type: string, year: number, index: number, uuid: string, savePripomienka: SavePripomienka, options?: RawAxiosRequestConfig) {
        return EditPripomienkaApiFp(this.configuration).editPripomienka(type, year, index, uuid, savePripomienka, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {SaveAdminPripomienka} saveAdminPripomienka 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EditPripomienkaApi
     */
    public editPripomienkaAdmin(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, saveAdminPripomienka: SaveAdminPripomienka, options?: RawAxiosRequestConfig) {
        return EditPripomienkaApiFp(this.configuration).editPripomienkaAdmin(classType, type, year, index, uuid, saveAdminPripomienka, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GetFilterDataApi - axios parameter creator
 * @export
 */
export const GetFilterDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterData: async (classType: ClassTypeEnum, type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('getFilterData', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getFilterData', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getFilterData', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getFilterData', 'index', index)
            const localVarPath = `/{classType}/{type}/{year}/{index}/get-filter-data`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GetFilterDataApi - functional programming interface
 * @export
 */
export const GetFilterDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GetFilterDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilterData(classType: ClassTypeEnum, type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilterData(classType, type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GetFilterDataApi.getFilterData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GetFilterDataApi - factory interface
 * @export
 */
export const GetFilterDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GetFilterDataApiFp(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterData(classType: ClassTypeEnum, type: string, year: number, index: number, options?: any): AxiosPromise<FilterData> {
            return localVarFp.getFilterData(classType, type, year, index, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GetFilterDataApi - object-oriented interface
 * @export
 * @class GetFilterDataApi
 * @extends {BaseAPI}
 */
export class GetFilterDataApi extends BaseAPI {
    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetFilterDataApi
     */
    public getFilterData(classType: ClassTypeEnum, type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return GetFilterDataApiFp(this.configuration).getFilterData(classType, type, year, index, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HromadnaPripomienkaListApi - axios parameter creator
 * @export
 */
export const HromadnaPripomienkaListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHromadnaPripomienkaList: async (type: string, year: number, index: number, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getHromadnaPripomienkaList', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getHromadnaPripomienkaList', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getHromadnaPripomienkaList', 'index', index)
            const localVarPath = `/hromadne-pripomienky/{type}/{year}/{index}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HromadnaPripomienkaListApi - functional programming interface
 * @export
 */
export const HromadnaPripomienkaListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HromadnaPripomienkaListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHromadnaPripomienkaList(type: string, year: number, index: number, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PripomienkaListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHromadnaPripomienkaList(type, year, index, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HromadnaPripomienkaListApi.getHromadnaPripomienkaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HromadnaPripomienkaListApi - factory interface
 * @export
 */
export const HromadnaPripomienkaListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HromadnaPripomienkaListApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHromadnaPripomienkaList(type: string, year: number, index: number, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: any): AxiosPromise<PripomienkaListPage> {
            return localVarFp.getHromadnaPripomienkaList(type, year, index, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HromadnaPripomienkaListApi - object-oriented interface
 * @export
 * @class HromadnaPripomienkaListApi
 * @extends {BaseAPI}
 */
export class HromadnaPripomienkaListApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {number} [page] Page number to return, indexed from zero.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HromadnaPripomienkaListApi
     */
    public getHromadnaPripomienkaList(type: string, year: number, index: number, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return HromadnaPripomienkaListApiFp(this.configuration).getHromadnaPripomienkaList(type, year, index, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HromadneVyhodnotenieApi - axios parameter creator
 * @export
 */
export const HromadneVyhodnotenieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {HromadneVyhodnotenie} hromadneVyhodnotenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hromadneVyhodnotit: async (classType: ClassTypeEnum, type: string, year: number, index: number, hromadneVyhodnotenie: HromadneVyhodnotenie, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('hromadneVyhodnotit', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('hromadneVyhodnotit', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('hromadneVyhodnotit', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('hromadneVyhodnotit', 'index', index)
            // verify required parameter 'hromadneVyhodnotenie' is not null or undefined
            assertParamExists('hromadneVyhodnotit', 'hromadneVyhodnotenie', hromadneVyhodnotenie)
            const localVarPath = `/{classType}/{type}/{year}/{index}/vyhodnot`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hromadneVyhodnotenie, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HromadneVyhodnotenieApi - functional programming interface
 * @export
 */
export const HromadneVyhodnotenieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HromadneVyhodnotenieApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {HromadneVyhodnotenie} hromadneVyhodnotenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hromadneVyhodnotit(classType: ClassTypeEnum, type: string, year: number, index: number, hromadneVyhodnotenie: HromadneVyhodnotenie, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hromadneVyhodnotit(classType, type, year, index, hromadneVyhodnotenie, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HromadneVyhodnotenieApi.hromadneVyhodnotit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HromadneVyhodnotenieApi - factory interface
 * @export
 */
export const HromadneVyhodnotenieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HromadneVyhodnotenieApiFp(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {HromadneVyhodnotenie} hromadneVyhodnotenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hromadneVyhodnotit(classType: ClassTypeEnum, type: string, year: number, index: number, hromadneVyhodnotenie: HromadneVyhodnotenie, options?: any): AxiosPromise<void> {
            return localVarFp.hromadneVyhodnotit(classType, type, year, index, hromadneVyhodnotenie, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HromadneVyhodnotenieApi - object-oriented interface
 * @export
 * @class HromadneVyhodnotenieApi
 * @extends {BaseAPI}
 */
export class HromadneVyhodnotenieApi extends BaseAPI {
    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {HromadneVyhodnotenie} hromadneVyhodnotenie 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HromadneVyhodnotenieApi
     */
    public hromadneVyhodnotit(classType: ClassTypeEnum, type: string, year: number, index: number, hromadneVyhodnotenie: HromadneVyhodnotenie, options?: RawAxiosRequestConfig) {
        return HromadneVyhodnotenieApiFp(this.configuration).hromadneVyhodnotit(classType, type, year, index, hromadneVyhodnotenie, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LdapSearchDataApi - axios parameter creator
 * @export
 */
export const LdapSearchDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get pouzivatel list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [searchToken] searchToken for pouzivatelska skupina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelListBySearchToken: async (type: string, year: number, index: number, searchToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPouzivatelListBySearchToken', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPouzivatelListBySearchToken', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getPouzivatelListBySearchToken', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/ldap-pouzivatel`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchToken !== undefined) {
                localVarQueryParameter['searchToken'] = searchToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get pouzivatelska skupina list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [searchToken] searchToken for pouzivatelska skupina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelskaSkupinaBySearchToken: async (type: string, year: number, index: number, searchToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPouzivatelskaSkupinaBySearchToken', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPouzivatelskaSkupinaBySearchToken', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getPouzivatelskaSkupinaBySearchToken', 'index', index)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/ldap-pouzivatelska-skupina`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchToken !== undefined) {
                localVarQueryParameter['searchToken'] = searchToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LdapSearchDataApi - functional programming interface
 * @export
 */
export const LdapSearchDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LdapSearchDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get pouzivatel list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [searchToken] searchToken for pouzivatelska skupina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPouzivatelListBySearchToken(type: string, year: number, index: number, searchToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LdapSearchItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPouzivatelListBySearchToken(type, year, index, searchToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LdapSearchDataApi.getPouzivatelListBySearchToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get pouzivatelska skupina list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [searchToken] searchToken for pouzivatelska skupina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPouzivatelskaSkupinaBySearchToken(type: string, year: number, index: number, searchToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LdapSearchItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPouzivatelskaSkupinaBySearchToken(type, year, index, searchToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LdapSearchDataApi.getPouzivatelskaSkupinaBySearchToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LdapSearchDataApi - factory interface
 * @export
 */
export const LdapSearchDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LdapSearchDataApiFp(configuration)
    return {
        /**
         * Get pouzivatel list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [searchToken] searchToken for pouzivatelska skupina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelListBySearchToken(type: string, year: number, index: number, searchToken?: string, options?: any): AxiosPromise<Array<LdapSearchItem>> {
            return localVarFp.getPouzivatelListBySearchToken(type, year, index, searchToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get pouzivatelska skupina list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} [searchToken] searchToken for pouzivatelska skupina
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPouzivatelskaSkupinaBySearchToken(type: string, year: number, index: number, searchToken?: string, options?: any): AxiosPromise<Array<LdapSearchItem>> {
            return localVarFp.getPouzivatelskaSkupinaBySearchToken(type, year, index, searchToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LdapSearchDataApi - object-oriented interface
 * @export
 * @class LdapSearchDataApi
 * @extends {BaseAPI}
 */
export class LdapSearchDataApi extends BaseAPI {
    /**
     * Get pouzivatel list by search token
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} [searchToken] searchToken for pouzivatelska skupina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LdapSearchDataApi
     */
    public getPouzivatelListBySearchToken(type: string, year: number, index: number, searchToken?: string, options?: RawAxiosRequestConfig) {
        return LdapSearchDataApiFp(this.configuration).getPouzivatelListBySearchToken(type, year, index, searchToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get pouzivatelska skupina list by search token
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} [searchToken] searchToken for pouzivatelska skupina
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LdapSearchDataApi
     */
    public getPouzivatelskaSkupinaBySearchToken(type: string, year: number, index: number, searchToken?: string, options?: RawAxiosRequestConfig) {
        return LdapSearchDataApiFp(this.configuration).getPouzivatelskaSkupinaBySearchToken(type, year, index, searchToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OdoslanaPripomienkaExistsApi - axios parameter creator
 * @export
 */
export const OdoslanaPripomienkaExistsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get pouzivatel list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {ClassTypeEnum} classTypeQuery Type of pripomienka
         * @param {PripomienkaFilter} pripomienkaFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odoslanaPripomienkaExists: async (type: string, year: number, index: number, classTypeQuery: ClassTypeEnum, pripomienkaFilter: PripomienkaFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('odoslanaPripomienkaExists', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('odoslanaPripomienkaExists', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('odoslanaPripomienkaExists', 'index', index)
            // verify required parameter 'classTypeQuery' is not null or undefined
            assertParamExists('odoslanaPripomienkaExists', 'classTypeQuery', classTypeQuery)
            // verify required parameter 'pripomienkaFilter' is not null or undefined
            assertParamExists('odoslanaPripomienkaExists', 'pripomienkaFilter', pripomienkaFilter)
            const localVarPath = `/legislativne-materialy/{type}/{year}/{index}/exists-odoslana`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (classTypeQuery !== undefined) {
                localVarQueryParameter['classTypeQuery'] = classTypeQuery;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pripomienkaFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OdoslanaPripomienkaExistsApi - functional programming interface
 * @export
 */
export const OdoslanaPripomienkaExistsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OdoslanaPripomienkaExistsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get pouzivatel list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {ClassTypeEnum} classTypeQuery Type of pripomienka
         * @param {PripomienkaFilter} pripomienkaFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async odoslanaPripomienkaExists(type: string, year: number, index: number, classTypeQuery: ClassTypeEnum, pripomienkaFilter: PripomienkaFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OdoslanaPripomienkaStatusEnum>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.odoslanaPripomienkaExists(type, year, index, classTypeQuery, pripomienkaFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OdoslanaPripomienkaExistsApi.odoslanaPripomienkaExists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OdoslanaPripomienkaExistsApi - factory interface
 * @export
 */
export const OdoslanaPripomienkaExistsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OdoslanaPripomienkaExistsApiFp(configuration)
    return {
        /**
         * Get pouzivatel list by search token
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {ClassTypeEnum} classTypeQuery Type of pripomienka
         * @param {PripomienkaFilter} pripomienkaFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odoslanaPripomienkaExists(type: string, year: number, index: number, classTypeQuery: ClassTypeEnum, pripomienkaFilter: PripomienkaFilter, options?: any): AxiosPromise<OdoslanaPripomienkaStatusEnum> {
            return localVarFp.odoslanaPripomienkaExists(type, year, index, classTypeQuery, pripomienkaFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OdoslanaPripomienkaExistsApi - object-oriented interface
 * @export
 * @class OdoslanaPripomienkaExistsApi
 * @extends {BaseAPI}
 */
export class OdoslanaPripomienkaExistsApi extends BaseAPI {
    /**
     * Get pouzivatel list by search token
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {ClassTypeEnum} classTypeQuery Type of pripomienka
     * @param {PripomienkaFilter} pripomienkaFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OdoslanaPripomienkaExistsApi
     */
    public odoslanaPripomienkaExists(type: string, year: number, index: number, classTypeQuery: ClassTypeEnum, pripomienkaFilter: PripomienkaFilter, options?: RawAxiosRequestConfig) {
        return OdoslanaPripomienkaExistsApiFp(this.configuration).odoslanaPripomienkaExists(type, year, index, classTypeQuery, pripomienkaFilter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PodporovatelApi - axios parameter creator
 * @export
 */
export const PodporovatelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPodporovatel: async (type: string, year: number, index: number, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('addPodporovatel', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('addPodporovatel', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('addPodporovatel', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('addPodporovatel', 'uuid', uuid)
            const localVarPath = `/hromadne-pripomienky/{type}/{year}/{index}/{uuid}/podpor`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePodporovatel: async (type: string, year: number, index: number, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('removePodporovatel', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('removePodporovatel', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('removePodporovatel', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('removePodporovatel', 'uuid', uuid)
            const localVarPath = `/hromadne-pripomienky/{type}/{year}/{index}/{uuid}/zrus-podporu`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PodporovatelApi - functional programming interface
 * @export
 */
export const PodporovatelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PodporovatelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPodporovatel(type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPodporovatel(type, year, index, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodporovatelApi.addPodporovatel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePodporovatel(type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePodporovatel(type, year, index, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodporovatelApi.removePodporovatel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PodporovatelApi - factory interface
 * @export
 */
export const PodporovatelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PodporovatelApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPodporovatel(type: string, year: number, index: number, uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.addPodporovatel(type, year, index, uuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePodporovatel(type: string, year: number, index: number, uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.removePodporovatel(type, year, index, uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PodporovatelApi - object-oriented interface
 * @export
 * @class PodporovatelApi
 * @extends {BaseAPI}
 */
export class PodporovatelApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodporovatelApi
     */
    public addPodporovatel(type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig) {
        return PodporovatelApiFp(this.configuration).addPodporovatel(type, year, index, uuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodporovatelApi
     */
    public removePodporovatel(type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig) {
        return PodporovatelApiFp(this.configuration).removePodporovatel(type, year, index, uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PodporovateliaApi - axios parameter creator
 * @export
 */
export const PodporovateliaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPodporovateliaList: async (type: string, year: number, index: number, uuid: string, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPodporovateliaList', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPodporovateliaList', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getPodporovateliaList', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPodporovateliaList', 'uuid', uuid)
            const localVarPath = `/podporovatelia/{type}/{year}/{index}/{uuid}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PodporovateliaApi - functional programming interface
 * @export
 */
export const PodporovateliaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PodporovateliaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPodporovateliaList(type: string, year: number, index: number, uuid: string, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PodporovatelListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPodporovateliaList(type, year, index, uuid, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PodporovateliaApi.getPodporovateliaList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PodporovateliaApi - factory interface
 * @export
 */
export const PodporovateliaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PodporovateliaApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPodporovateliaList(type: string, year: number, index: number, uuid: string, page?: number, options?: any): AxiosPromise<PodporovatelListPage> {
            return localVarFp.getPodporovateliaList(type, year, index, uuid, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PodporovateliaApi - object-oriented interface
 * @export
 * @class PodporovateliaApi
 * @extends {BaseAPI}
 */
export class PodporovateliaApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {number} [page] Page number to return, indexed from zero.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PodporovateliaApi
     */
    public getPodporovateliaList(type: string, year: number, index: number, uuid: string, page?: number, options?: RawAxiosRequestConfig) {
        return PodporovateliaApiFp(this.configuration).getPodporovateliaList(type, year, index, uuid, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PripomienkaDetailApi - axios parameter creator
 * @export
 */
export const PripomienkaDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPripomienkaDetail: async (classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('getPripomienkaDetail', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPripomienkaDetail', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPripomienkaDetail', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getPripomienkaDetail', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('getPripomienkaDetail', 'uuid', uuid)
            const localVarPath = `/{classType}/{type}/{year}/{index}/{uuid}`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PripomienkaDetailApi - functional programming interface
 * @export
 */
export const PripomienkaDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PripomienkaDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPripomienkaDetail(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PripomienkaDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPripomienkaDetail(classType, type, year, index, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PripomienkaDetailApi.getPripomienkaDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PripomienkaDetailApi - factory interface
 * @export
 */
export const PripomienkaDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PripomienkaDetailApiFp(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPripomienkaDetail(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, options?: any): AxiosPromise<PripomienkaDetail> {
            return localVarFp.getPripomienkaDetail(classType, type, year, index, uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PripomienkaDetailApi - object-oriented interface
 * @export
 * @class PripomienkaDetailApi
 * @extends {BaseAPI}
 */
export class PripomienkaDetailApi extends BaseAPI {
    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PripomienkaDetailApi
     */
    public getPripomienkaDetail(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig) {
        return PripomienkaDetailApiFp(this.configuration).getPripomienkaDetail(classType, type, year, index, uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PripomienkaFilterListApi - axios parameter creator
 * @export
 */
export const PripomienkaFilterListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PripomienkaFilter} pripomienkaFilter 
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPripomienkaFilterList: async (classType: ClassTypeEnum, type: string, year: number, index: number, pripomienkaFilter: PripomienkaFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('getPripomienkaFilterList', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPripomienkaFilterList', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPripomienkaFilterList', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getPripomienkaFilterList', 'index', index)
            // verify required parameter 'pripomienkaFilter' is not null or undefined
            assertParamExists('getPripomienkaFilterList', 'pripomienkaFilter', pripomienkaFilter)
            const localVarPath = `/{classType}/{type}/{year}/{index}/filter`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pripomienkaFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PripomienkaFilterListApi - functional programming interface
 * @export
 */
export const PripomienkaFilterListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PripomienkaFilterListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PripomienkaFilter} pripomienkaFilter 
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPripomienkaFilterList(classType: ClassTypeEnum, type: string, year: number, index: number, pripomienkaFilter: PripomienkaFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PripomienkaListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPripomienkaFilterList(classType, type, year, index, pripomienkaFilter, page, size, sortBy, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PripomienkaFilterListApi.getPripomienkaFilterList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PripomienkaFilterListApi - factory interface
 * @export
 */
export const PripomienkaFilterListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PripomienkaFilterListApiFp(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {PripomienkaFilter} pripomienkaFilter 
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {number} [size] Size of page to return.
         * @param {string} [sortBy] 
         * @param {SortDirectionEnum} [sortDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPripomienkaFilterList(classType: ClassTypeEnum, type: string, year: number, index: number, pripomienkaFilter: PripomienkaFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: any): AxiosPromise<PripomienkaListPage> {
            return localVarFp.getPripomienkaFilterList(classType, type, year, index, pripomienkaFilter, page, size, sortBy, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PripomienkaFilterListApi - object-oriented interface
 * @export
 * @class PripomienkaFilterListApi
 * @extends {BaseAPI}
 */
export class PripomienkaFilterListApi extends BaseAPI {
    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {PripomienkaFilter} pripomienkaFilter 
     * @param {number} [page] Page number to return, indexed from zero.
     * @param {number} [size] Size of page to return.
     * @param {string} [sortBy] 
     * @param {SortDirectionEnum} [sortDirection] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PripomienkaFilterListApi
     */
    public getPripomienkaFilterList(classType: ClassTypeEnum, type: string, year: number, index: number, pripomienkaFilter: PripomienkaFilter, page?: number, size?: number, sortBy?: string, sortDirection?: SortDirectionEnum, options?: RawAxiosRequestConfig) {
        return PripomienkaFilterListApiFp(this.configuration).getPripomienkaFilterList(classType, type, year, index, pripomienkaFilter, page, size, sortBy, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RemovePripomienkaApi - axios parameter creator
 * @export
 */
export const RemovePripomienkaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePripomienka: async (classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('removePripomienka', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('removePripomienka', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('removePripomienka', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('removePripomienka', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('removePripomienka', 'uuid', uuid)
            const localVarPath = `/{classType}/{type}/{year}/{index}/{uuid}/remove`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RemovePripomienkaApi - functional programming interface
 * @export
 */
export const RemovePripomienkaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RemovePripomienkaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePripomienka(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePripomienka(classType, type, year, index, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemovePripomienkaApi.removePripomienka']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RemovePripomienkaApi - factory interface
 * @export
 */
export const RemovePripomienkaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RemovePripomienkaApiFp(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePripomienka(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.removePripomienka(classType, type, year, index, uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RemovePripomienkaApi - object-oriented interface
 * @export
 * @class RemovePripomienkaApi
 * @extends {BaseAPI}
 */
export class RemovePripomienkaApi extends BaseAPI {
    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemovePripomienkaApi
     */
    public removePripomienka(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig) {
        return RemovePripomienkaApiFp(this.configuration).removePripomienka(classType, type, year, index, uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RemoveSubjektBezPripomienokApi - axios parameter creator
 * @export
 */
export const RemoveSubjektBezPripomienokApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSubjektBezPripomienok: async (type: string, year: number, index: number, uuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('removeSubjektBezPripomienok', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('removeSubjektBezPripomienok', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('removeSubjektBezPripomienok', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('removeSubjektBezPripomienok', 'uuid', uuid)
            const localVarPath = `/pripomienky/{type}/{year}/{index}/{uuid}/remove-subjekt`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RemoveSubjektBezPripomienokApi - functional programming interface
 * @export
 */
export const RemoveSubjektBezPripomienokApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RemoveSubjektBezPripomienokApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSubjektBezPripomienok(type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSubjektBezPripomienok(type, year, index, uuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemoveSubjektBezPripomienokApi.removeSubjektBezPripomienok']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RemoveSubjektBezPripomienokApi - factory interface
 * @export
 */
export const RemoveSubjektBezPripomienokApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RemoveSubjektBezPripomienokApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSubjektBezPripomienok(type: string, year: number, index: number, uuid: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeSubjektBezPripomienok(type, year, index, uuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RemoveSubjektBezPripomienokApi - object-oriented interface
 * @export
 * @class RemoveSubjektBezPripomienokApi
 * @extends {BaseAPI}
 */
export class RemoveSubjektBezPripomienokApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemoveSubjektBezPripomienokApi
     */
    public removeSubjektBezPripomienok(type: string, year: number, index: number, uuid: string, options?: RawAxiosRequestConfig) {
        return RemoveSubjektBezPripomienokApiFp(this.configuration).removeSubjektBezPripomienok(type, year, index, uuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SendBezPripomienokApi - axios parameter creator
 * @export
 */
export const SendBezPripomienokApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBezPripomienok: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('sendBezPripomienok', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('sendBezPripomienok', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('sendBezPripomienok', 'index', index)
            const localVarPath = `/pripomienky/{type}/{year}/{index}/odoslat-bez-pripomienok`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {AddSubjektBezPripomienok} addSubjektBezPripomienok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBezPripomienokAdmin: async (type: string, year: number, index: number, addSubjektBezPripomienok: AddSubjektBezPripomienok, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('sendBezPripomienokAdmin', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('sendBezPripomienokAdmin', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('sendBezPripomienokAdmin', 'index', index)
            // verify required parameter 'addSubjektBezPripomienok' is not null or undefined
            assertParamExists('sendBezPripomienokAdmin', 'addSubjektBezPripomienok', addSubjektBezPripomienok)
            const localVarPath = `/pripomienky/{type}/{year}/{index}/odoslat-bez-pripomienok-admin`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addSubjektBezPripomienok, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SendBezPripomienokApi - functional programming interface
 * @export
 */
export const SendBezPripomienokApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SendBezPripomienokApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBezPripomienok(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBezPripomienok(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SendBezPripomienokApi.sendBezPripomienok']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {AddSubjektBezPripomienok} addSubjektBezPripomienok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBezPripomienokAdmin(type: string, year: number, index: number, addSubjektBezPripomienok: AddSubjektBezPripomienok, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBezPripomienokAdmin(type, year, index, addSubjektBezPripomienok, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SendBezPripomienokApi.sendBezPripomienokAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SendBezPripomienokApi - factory interface
 * @export
 */
export const SendBezPripomienokApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SendBezPripomienokApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBezPripomienok(type: string, year: number, index: number, options?: any): AxiosPromise<void> {
            return localVarFp.sendBezPripomienok(type, year, index, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {AddSubjektBezPripomienok} addSubjektBezPripomienok 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBezPripomienokAdmin(type: string, year: number, index: number, addSubjektBezPripomienok: AddSubjektBezPripomienok, options?: any): AxiosPromise<void> {
            return localVarFp.sendBezPripomienokAdmin(type, year, index, addSubjektBezPripomienok, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SendBezPripomienokApi - object-oriented interface
 * @export
 * @class SendBezPripomienokApi
 * @extends {BaseAPI}
 */
export class SendBezPripomienokApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendBezPripomienokApi
     */
    public sendBezPripomienok(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return SendBezPripomienokApiFp(this.configuration).sendBezPripomienok(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {AddSubjektBezPripomienok} addSubjektBezPripomienok 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendBezPripomienokApi
     */
    public sendBezPripomienokAdmin(type: string, year: number, index: number, addSubjektBezPripomienok: AddSubjektBezPripomienok, options?: RawAxiosRequestConfig) {
        return SendBezPripomienokApiFp(this.configuration).sendBezPripomienokAdmin(type, year, index, addSubjektBezPripomienok, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SendPripomienkyApi - axios parameter creator
 * @export
 */
export const SendPripomienkyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPripomienkyForSend: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPripomienkyForSend', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getPripomienkyForSend', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getPripomienkyForSend', 'index', index)
            const localVarPath = `/pripomienky/{type}/{year}/{index}/pripomienky-na-odoslanie`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPripomienky: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('sendPripomienky', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('sendPripomienky', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('sendPripomienky', 'index', index)
            const localVarPath = `/pripomienky/{type}/{year}/{index}/odoslat`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SendPripomienkyApi - functional programming interface
 * @export
 */
export const SendPripomienkyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SendPripomienkyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPripomienkyForSend(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PripomienkaListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPripomienkyForSend(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SendPripomienkyApi.getPripomienkyForSend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPripomienky(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPripomienky(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SendPripomienkyApi.sendPripomienky']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SendPripomienkyApi - factory interface
 * @export
 */
export const SendPripomienkyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SendPripomienkyApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPripomienkyForSend(type: string, year: number, index: number, options?: any): AxiosPromise<Array<PripomienkaListItem>> {
            return localVarFp.getPripomienkyForSend(type, year, index, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPripomienky(type: string, year: number, index: number, options?: any): AxiosPromise<void> {
            return localVarFp.sendPripomienky(type, year, index, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SendPripomienkyApi - object-oriented interface
 * @export
 * @class SendPripomienkyApi
 * @extends {BaseAPI}
 */
export class SendPripomienkyApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendPripomienkyApi
     */
    public getPripomienkyForSend(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return SendPripomienkyApiFp(this.configuration).getPripomienkyForSend(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendPripomienkyApi
     */
    public sendPripomienky(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return SendPripomienkyApiFp(this.configuration).sendPripomienky(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubjektBezPripomienokListApi - axios parameter creator
 * @export
 */
export const SubjektBezPripomienokListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjektBezPripomienokList: async (type: string, year: number, index: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getSubjektBezPripomienokList', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getSubjektBezPripomienokList', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getSubjektBezPripomienokList', 'index', index)
            const localVarPath = `/subjekty-bez-pripomienok/{type}/{year}/{index}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubjektBezPripomienokListApi - functional programming interface
 * @export
 */
export const SubjektBezPripomienokListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubjektBezPripomienokListApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubjektBezPripomienokList(type: string, year: number, index: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubjektBezPripomienokListPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubjektBezPripomienokList(type, year, index, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubjektBezPripomienokListApi.getSubjektBezPripomienokList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubjektBezPripomienokListApi - factory interface
 * @export
 */
export const SubjektBezPripomienokListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubjektBezPripomienokListApiFp(configuration)
    return {
        /**
         * 
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {number} [page] Page number to return, indexed from zero.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjektBezPripomienokList(type: string, year: number, index: number, page?: number, options?: any): AxiosPromise<SubjektBezPripomienokListPage> {
            return localVarFp.getSubjektBezPripomienokList(type, year, index, page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubjektBezPripomienokListApi - object-oriented interface
 * @export
 * @class SubjektBezPripomienokListApi
 * @extends {BaseAPI}
 */
export class SubjektBezPripomienokListApi extends BaseAPI {
    /**
     * 
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {number} [page] Page number to return, indexed from zero.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubjektBezPripomienokListApi
     */
    public getSubjektBezPripomienokList(type: string, year: number, index: number, page?: number, options?: RawAxiosRequestConfig) {
        return SubjektBezPripomienokListApiFp(this.configuration).getSubjektBezPripomienokList(type, year, index, page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current logged user data with LP
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserWithLp: async (type: string, year: number, index: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getCurrentUserWithLp', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('getCurrentUserWithLp', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('getCurrentUserWithLp', 'index', index)
            const localVarPath = `/aktualny-pouzivatel/{type}/{year}/{index}`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current logged user data with LP
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserWithLp(type: string, year: number, index: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailWithLp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserWithLp(type, year, index, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getCurrentUserWithLp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Get current logged user data with LP
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserWithLp(type: string, year: number, index: number, options?: any): AxiosPromise<UserDetailWithLp> {
            return localVarFp.getCurrentUserWithLp(type, year, index, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Get current logged user data with LP
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getCurrentUserWithLp(type: string, year: number, index: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getCurrentUserWithLp(type, year, index, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VyhodnotenieApi - axios parameter creator
 * @export
 */
export const VyhodnotenieApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {Vyhodnotenie} vyhodnotenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vyhodnotenie: async (classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, vyhodnotenie: Vyhodnotenie, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'classType' is not null or undefined
            assertParamExists('vyhodnotenie', 'classType', classType)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('vyhodnotenie', 'type', type)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('vyhodnotenie', 'year', year)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('vyhodnotenie', 'index', index)
            // verify required parameter 'uuid' is not null or undefined
            assertParamExists('vyhodnotenie', 'uuid', uuid)
            // verify required parameter 'vyhodnotenie' is not null or undefined
            assertParamExists('vyhodnotenie', 'vyhodnotenie', vyhodnotenie)
            const localVarPath = `/{classType}/{type}/{year}/{index}/{uuid}/vyhodnot`
                .replace(`{${"classType"}}`, encodeURIComponent(String(classType)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"year"}}`, encodeURIComponent(String(year)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)))
                .replace(`{${"uuid"}}`, encodeURIComponent(String(uuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vyhodnotenie, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VyhodnotenieApi - functional programming interface
 * @export
 */
export const VyhodnotenieApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VyhodnotenieApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {Vyhodnotenie} vyhodnotenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vyhodnotenie(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, vyhodnotenie: Vyhodnotenie, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Uuid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vyhodnotenie(classType, type, year, index, uuid, vyhodnotenie, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VyhodnotenieApi.vyhodnotenie']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VyhodnotenieApi - factory interface
 * @export
 */
export const VyhodnotenieApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VyhodnotenieApiFp(configuration)
    return {
        /**
         * 
         * @param {ClassTypeEnum} classType Type of pripomienka
         * @param {string} type Type of legislation process
         * @param {number} year Year of legislation process
         * @param {number} index Number of legislation process
         * @param {string} uuid Primary key of entity
         * @param {Vyhodnotenie} vyhodnotenie 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vyhodnotenie(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, vyhodnotenie: Vyhodnotenie, options?: any): AxiosPromise<Uuid> {
            return localVarFp.vyhodnotenie(classType, type, year, index, uuid, vyhodnotenie, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VyhodnotenieApi - object-oriented interface
 * @export
 * @class VyhodnotenieApi
 * @extends {BaseAPI}
 */
export class VyhodnotenieApi extends BaseAPI {
    /**
     * 
     * @param {ClassTypeEnum} classType Type of pripomienka
     * @param {string} type Type of legislation process
     * @param {number} year Year of legislation process
     * @param {number} index Number of legislation process
     * @param {string} uuid Primary key of entity
     * @param {Vyhodnotenie} vyhodnotenie 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VyhodnotenieApi
     */
    public vyhodnotenie(classType: ClassTypeEnum, type: string, year: number, index: number, uuid: string, vyhodnotenie: Vyhodnotenie, options?: RawAxiosRequestConfig) {
        return VyhodnotenieApiFp(this.configuration).vyhodnotenie(classType, type, year, index, uuid, vyhodnotenie, options).then((request) => request(this.axios, this.basePath));
    }
}



